<template>
  <v-container class="pa-1">
    <div class="text-right">
      <NewCompany
        v-if="company.id == 'OaaRuxV6tA3nobp42xMq' || company.id == 'R1XBW59p2FFxo5WudH3H'"
      />
      <InviteAdmins :company="company" />
    </div>
    <h4>{{ $t("company.tabs.administrators.description") }} {{ company.name }}</h4>
    <v-data-table :headers="headers" :items="tableUsers" :items-per-page="15">
      <template v-slot:[`item.profile_pic`]="{ item }">
        <v-avatar size="40">
          <v-img :src="imageUrls[item.id] || require('@/assets/profile_pic_empty.png')"></v-img>
        </v-avatar>
      </template>

      <template>
        <!--v-slot:item.action="{ item }"> -->
        <div class="text-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">mdi-dots-horizontal</v-icon>
            </template>
            <v-list>
              <!-- <v-list-item v-if="canRemoveAdmin(item)" @click="switchAdmin(item)">
        <v-list-item-title>{{type=='admins' ? 'Remove Admin' : 'Make Admin'}}</v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-title @click="sendEmail(item.email)">Email</v-list-item-title>
                            </v-list-item>-->
              <!-- <v-list-item>
                                            <v-list-item-title>Delete</v-list-item-title>
                            </v-list-item>-->
            </v-list>
          </v-menu>
        </div>
      </template>

      <template v-slot:no-data>
        <h2>{{ $t("company.tabs.administrators.no_admin") }}</h2>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import InviteAdmins from "./InviteAdmin";
import NewCompany from "./NewCompany";

export default {
  name: "Administrators",
  components: { InviteAdmins, NewCompany },
  props: ["companyId"],
  data() {
    return {
      headers: [
        {
          text: "",
          value: "profile_pic",
          sortable: false,
          width: "50px",
        },
        {
          text: this.$t("common.name"),
          align: "left",
          value: "name",
        },
        {
          text: this.$t("common.email"),
          value: "email",
          sortable: false,
        },
        {
          text: this.$t("common.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ],
    };
  },

  computed: {
    company() {
      return this.$store.state.companies[this.$props.companyId];
    },
    tableUsers() {
      if (!this.company) return [];
      const { admins, invites } = this.company;
      const allUsers = this.$store.state.users;
      const users = [];
      Object.keys(admins).forEach((key) => {
        const user = allUsers[key];
        if (user) {
          users.push(user);
        }
      });
      if (invites) {
        invites.forEach((invite) => {
          users.push({ email: invite, name: `${invite.split("@").shift()} (pending)` });
        });
      }

      console.log(users);
      return users;
    },
    imageUrls() {
      return this.$store.state.imageUrls;
    },
  },
  filters: {
    capitalize: (value) => {
      if (!value) return "";
      const val = value.toString();
      return val.charAt(0).toUpperCase() + val.slice(1);
    },
  },
};
</script>
